import React from 'react';
import CustomImage from '../../../components/custom-image';

const Aluminium = () => {
  return (
    <div className="card">
      <div className="title">
        <div className="icon">
          <CustomImage className="custom-image" imageName="icon-aluminium-lg.png" alt="Aluminium" maxWidth="90" />
        </div>
        <div className="text">
          <h4>Aluminium</h4>
        </div>
      </div>
      <div className="middle-text">
        <h3 className="blue-text">37%</h3>
        <p>
          market share in <br /> primary <br /> Indian aluminium market
        </p>
      </div>
      <div className="bottom-text">
        <p className="title-cr">EBITDA (In INR Cr.)</p>
        <p className="blue1">1,998</p>
      </div>
    </div>
  );
};

export default Aluminium;
